import React from "react";
import { Grid } from "@material-ui/core";

import { Wrapper } from "./styles";
import Botao from "../../../../../componentes/botao";
import { paletas } from "../../../../../styles/theme";
import { TipoAlgoritmoEnum } from "../../../../../enums/tipo-algoritmo.enum";

type Props = {
  resultado: number;
  bloquear: boolean;
  register: any;
  tipoAlgoritmo: number;
};

export default function Questoes({
  resultado,
  bloquear,
  register,
  tipoAlgoritmo,
}: Props) {
  const listaAlternativa: string[] = ["A", "B", "C", "D", "E"];
  const respostas = React.useMemo(() => {
    let listaRes: number[] = [];

    // Inserindo resposta correta
    listaRes.push(resultado);

    // Inserindo respostas alternativas (erradas)
    for (let i = 0; i < 4; i++) {
      // Gerando números
      const numRandom: number =
        listaRes[0] + i + Math.floor(Math.random() * 11);
      const numRandomNeg: number =
        listaRes[0] + i + Math.floor(Math.random() * -11);

      // Verifica se existe resposta duplicada
      const varRepetiu = listaRes.find((item) => item === numRandom);

      // Insere respostas únicas
      if (!varRepetiu) {
        listaRes.push(numRandom);
      } else {
        listaRes.push(numRandomNeg * 2);
      }
    }

    // Embaralhar respostas
    for (let i = 0; i < listaRes.length; i++) {
      listaRes = listaRes.sort(() => Math.random() * 2 - 1);
    }

    // console.log(resultado); // DELETAR
    return listaRes;
  }, [resultado]);

  return (
    <Wrapper>
      {TipoAlgoritmoEnum.REPETICOES === tipoAlgoritmo ? (
        <h4>Qual o valor final de "numeroN"?</h4>
      ) : (
        <h4>Qual o valor de "resultado"?</h4>
      )}

      {respostas.map((item, idx) => {
        return (
          <Grid key={idx}>
            <input
              type="radio"
              id={listaAlternativa[idx]}
              value={item}
              {...register("resposta")}
              disabled={bloquear}
              required
            />
            <label htmlFor={listaAlternativa[idx]}>
              <span></span>
              {item}
            </label>
          </Grid>
        );
      })}

      <Botao
        type="submit"
        color={paletas.Grafite75}
        background={paletas.DarkOrange}
        border={paletas.DarkOrange}
        disabled={bloquear}
        size="18px"
        onClick={() => null}
        value="CONFIRMAR RESPOSTA"
      />
    </Wrapper>
  );
}
